import React, { useEffect, useState, useRef } from 'react'; //import React Component
import { cloudStore } from '../firebase';
import { collection, query, where, doc, updateDoc, setDoc, getDoc, getDocs } from 'firebase/firestore';

export function Alluser() {
    const [userCollection, setuserCollection] = useState([])
    // Show create
    useEffect(() => {
        getDocs(query(collection(cloudStore, "userData"), where("Personal_Information", "!=", null)))
            .then((querySnapshot) => {
                const data = querySnapshot.docs.map((doc) => doc.data());
                data.sort((a, b) => b["会员等级"]["buyingPower"] - a["会员等级"]["buyingPower"])
                    .sort((a, b) => b.officer - a.officer)
                setuserCollection(data)
            })
    }, []);

    const [ifGiveOutCoupon, setifGiveOutCoupon] = useState(false)
    const [userID, setuserID] = useState("")
    const openaddcoupon = (e) => {
        let value = e.target.dataset.value
        setuserID(value)
        if (ifGiveOutCoupon) {
            setifGiveOutCoupon(false)
        } else {
            setifGiveOutCoupon(true)
        }
    }

    const [giveMoney, setgiveMoney] = useState("")
    const handleInputChange = (e) => {
        let { value } = e.target
        setgiveMoney(value)
        if (giveMoney.trim().length > 0) {
            document.getElementsByTagName("label")[0].style.color = "black"
        }
    }

    const giveACoupon = async () => {
        const userName = localStorage.getItem("currentLoginUser");
        const userExist = await getDocs(query(collection(cloudStore, "userData"), where("Personal_Information.name", "==", userName)));
        const userData = userExist.docs.map(doc => doc.data());

        const userExist2 = await getDocs(query(collection(cloudStore, "userData"), where("Personal_Information.userID", "==", userID)));
        const userData2 = userExist2.docs.map(doc => doc.data());
        var newDiv = document.createElement("div");
        var text = "";
        newDiv.classList.add("tips");
        setTimeout(() => { newDiv.style.display = "none" }, 4500);
        let button = document.querySelector(".submit");

        if (userData[0]) {
            if (userData[0].officer === true) {
                if (giveMoney.trim().length > 0) {
                    if (userData2.length > 0) {
                        const dataExist = await getDoc(doc(cloudStore, "userCoupon", userID)); //Data exsit
                        if (dataExist.exists()) {
                            const docRef = doc(cloudStore, "userCoupon", userID);
                            const docSnap = await getDoc(docRef);
                            const addCoupon = docSnap.exists() ? docSnap.data()["Coupon_Information"].金额 : [];
                            const updatedCoupon = [...addCoupon, parseFloat(giveMoney)];
                            updateDoc(docRef, { "Coupon_Information.金额": updatedCoupon })
                                .then(() => {
                                    var newDiv2 = document.createElement("div");
                                    var text = document.createTextNode(" Finished");
                                    newDiv2.classList.add("tips");
                                    newDiv2.appendChild(text);
                                    newDiv2.style.color = "red"
                                    button.after(newDiv2);
                                    setTimeout(() => { window.location.reload() }, 500);
                                })
                        } else {
                            const docData = {
                                "Coupon_Information": {
                                    ownerID: userID,
                                    金额: [giveMoney]
                                }
                            }
                            setDoc(doc(cloudStore, "userCoupon", userID), docData).then(() => {
                                var newDiv2 = document.createElement("div");
                                var text = document.createTextNode(" Finished");
                                newDiv2.classList.add("tips");
                                newDiv2.appendChild(text);
                                newDiv2.style.color = "red"
                                button.after(newDiv2);
                                setTimeout(() => { window.location.reload() }, 500);
                            })
                        }
                        text = document.createTextNode("Wait for Processing. Do not Reflesh the page utill you saw the finish message");
                        newDiv.appendChild(text);
                        button.after(newDiv);

                    } else {
                        text = document.createTextNode("你填写的用户不存在.");
                        newDiv.appendChild(text);
                        button.after(newDiv);
                    }
                } else {
                    text = document.createTextNode("Please fillout the important blanks.");
                    newDiv.appendChild(text);
                    button.after(newDiv);
                    if (giveMoney.trim().length === 0) {
                        document.getElementsByTagName("label")[0].style.color = "red"
                    }
                }
            } else {
                text = document.createTextNode("You are not officer.");
                newDiv.appendChild(text);
                button.after(newDiv);
            }
        } else {
            text = document.createTextNode("You have not signin.");
            newDiv.appendChild(text);
            button.after(newDiv);
        }
    }

    let eachCollection = null
    if (userCollection.length > 0) {
        eachCollection = userCollection.map((content) => {
            let name = content.Personal_Information.name
            let location = content.Personal_Information.location
            let phone = content.Personal_Information.phone
            let userID = content.Personal_Information.userID
            let wechat = content.Personal_Information.wechat
            let buyingPower = content.会员等级.buyingPower
            // let level = content.会员等级.level
            let officer = content.officer
            let officerContent = ""
            if (officer) {
                officerContent = "This is Officer"
            }

            return (
                <div className="each" key={userID} style={{ textAlign: "left", padding: "10px", width: "240px" }}>
                    {officer === false ?
                        <>
                            <div>
                                <h2>{name}</h2>
                                <div style={{ paddingLeft: "10px" }}>
                                    <h3>{officerContent}</h3>
                                    <p>ID: {userID}</p>
                                    <p>住址：{location}</p>
                                    <p>手机号：{phone}</p>
                                    <p>微信号：{wechat}</p>
                                    <p>总消费额：{buyingPower}$</p>
                                </div>
                            </div>
                            <div
                                className="button profile_explore"
                                onClick={(e) => openaddcoupon(e)}
                                data-value={userID}>
                                给予优惠卷
                            </div>
                        </> : null
                    }

                    {officer === true ?
                        <>
                            <div>
                                <h2>{name}</h2>
                                <div style={{ paddingLeft: "10px" }}>
                                    <h3>{officerContent}</h3>
                                    <p>ID: {userID}</p>
                                </div>
                            </div>
                        </> : null
                    }
                </div >
            )
        })
    }

    return (
        <div className='collection_content' style={{ marginTop: "50px" }}>
            <div className='h2bg'>
                <h2>All users</h2>
                <h3>用户总量：{userCollection.length}</h3>
            </div>
            <div className="store" style={{ marginTop: "50px" }}>
                {eachCollection}
            </div>
            {ifGiveOutCoupon === true ?
                <>
                    <div>
                        <div className='forCloseFullSreen' onClick={openaddcoupon}></div>
                        <div className='fillCoupon'>
                            <form>
                                <div className='fillContent'>
                                    <div>
                                        <label htmlFor="giveout">给予对象金额: </label>
                                        <input
                                            type="number"
                                            id="giveMoney"
                                            placeholder="你想给予他多少金额？"
                                            onChange={(e) => { handleInputChange(e) }}
                                            value={giveMoney}
                                        />
                                    </div>
                                    <div className="button submit" style={{ margin: "40px auto 0 auto" }} onClick={giveACoupon}>Submit</div>
                                </div>
                            </form>
                        </div>
                    </div>
                </> : null
            }
        </div>
    );
}